<template>
    <div class="menu_bar">
        <router-link :to='path' class="router">
            <div class='vertical_align_div'>
                <img class='nav_icon' :src='icon'>
                {{title}}
            </div>
        </router-link>
    </div>
</template>
<script>

export default {
  props: ['icon', 'title', 'path'],
  data () {
    return {
    }
  }
}
</script>
<style scoped>
.active .router {
    background-color: #A7F1FF
}
:not(.active).menu_list_nav .router {
    background-color: #BBFFFF
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/menubar.vue